<template>
  <transition
    :name="`transition-swipe-${direction}`"
    mode="out-in"
    @after-enter="afterTransition"
  >
    <slot />
  </transition>
</template>

<script>
  export default {
    name: 'ZgTransitionSwipe',
    props: {
      direction: {
        type: String,
        required: false,
        default: 'left',
        validator: (value) => {
          return ['right', 'left'].indexOf(value) !== -1
        }
      }
    },
    methods: {
      afterTransition () {
        this.$emit('after-transition')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .transition-swipe-left-enter-active,
  .transition-swipe-left-leave-active,
  .transition-swipe-right-enter-active,
  .transition-swipe-right-leave-active {
    transition: all 0.15s ease-in-out;
  }

  /* Left */
  .transition-swipe-left-enter {
    transform: translateX(100%);
    opacity: 0;

    @include mq(medium) {
      transform: translateX(20%);
    }
  }

  .transition-swipe-left-enter-to {
    transform: translateX(0);
    opacity: 1;
  }

  .transition-swipe-left-leave {
    transform: translateX(0);
    opacity: 1;
  }

  .transition-swipe-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;

    @include mq(medium) {
      transform: translateX(-20%);
    }
  }

  /* Right */
  .transition-swipe-right-enter {
    transform: translateX(-100%);
    opacity: 0;

    @include mq(medium) {
      transform: translateX(-20%);
    }
  }

  .transition-swipe-right-enter-to {
    transform: translateX(0);
    opacity: 1;
  }

  .transition-swipe-right-leave {
    transform: translateX(0);
    opacity: 1;
  }

  .transition-swipe-right-leave-to {
    transform: translateX(100%);
    opacity: 0;

    @include mq(medium) {
      transform: translateX(20%);
    }
  }
</style>
